<template>
<section class="view-wrap three-quarters">
	<Heading :level="1" text="Create an account" />

	<UserMessage v-if="error" message-type="error" :message-text="error" />

	<form @submit.prevent novalidate ref="form">
		<form-field-set>
			<template #legend>
				<legend class="sr-only">Please register your details to create an account</legend>
			</template>
			<template #fields>
				<InputField
					name="firstname"
					ref="firstname"
					label-text="First name"
					placeholder="Simon"
					:value="formData.GivenName"
					@emitFieldData="(val) => formData.GivenName = val"
					required-error="Please provide your first name" />

				<InputField
					name="lastname"
					ref="lastname"
					label-text="Last name"
					placeholder="Belmont"
					:value="formData.Surname"
					@emitFieldData="(val) => formData.Surname = val"
					required-error="Please provide your last name" />

				<InputField
					name="email"
					ref="email"
					label-text="Email"
					:help-text="{text: 'Please take care when entering your email address as we will need to verify it'}"
					placeholder="me@example.com"
					:value="formData.Mail"
					@emitFieldData="(val) => formData.Mail = val"
					input-type="email"
					required-error="Please provide your email address"
					:validation-rules="[rules.validateEmail]" />

				<InputField
					name="telephone"
					ref="telephone"
					label-text="Contact telephone number"
					input-type="tel"
					placeholder="0000 000 0000"
					:value="formData.MobilePhone"
					@emitFieldData="(val) => formData.MobilePhone = val"
					required-error="Please provide your telephone number"
					:validation-rules="[rules.validateTel]" />

				<PasswordField
					name="password"
					ref="password"
					label-text="Password"
					:value="formData.Password"
					@emitFieldData="(val) => formData.Password = val"
					:validation-rules="[rules.validatePassword]" />

				<PasswordField
					name="confPassword"
					ref="confPassword"
					label-text="Confirm your password"
					:value="confPassword"
					@emitFieldData="(val) => confPassword = val"
					:validation-rules="[passwordsMatch]" />
			</template>
		</form-field-set>

		<Button
			class="primary m-t-3"
			button-type="submit"
			text="Register"
			loading-text="Submitting"
			:is-disabled="formSubmitting"
			:is-loading="formSubmitting"
			@btnClick="register" />
	</form>
	<div class="flex m-t-2">
		<router-link to="login">Already have an account? Login here.</router-link>
	</div>
</section>
</template>

<script>
import { mapActions } from 'vuex';
import { formValidator } from '@/mixins/formValidator';
import { validationRules } from '@/utilities/validationRules';

export default {
	name: 'RegisterView',
	mixins: [formValidator],
	data () {
		return {
			error: '',
			formSubmitting: false,
			rules: validationRules,
			confPassword: '',
			formData: {
				GivenName: '',
				Surname: '',
				Mail: '',
				MobilePhone: '',
				Password: ''
			}
		};
	},
	head: {
		title: `Register your account | ${process.env.VUE_APP_FUND_NAME}`,
		meta: [
			{ name: 'description', content: `${process.env.VUE_APP_FUND_NAME} account registration` }
		]
	},
	methods: {
		register () {
			this.error = '';
			if (this.isValid(this.$refs.form)) {
				this.formSubmitting = true;
				this.registerUser({ ...this.formData, BusinessUnit: process.env.VUE_APP_BUSINESS_UNIT }).then((res) => {
					if (res.status === 200) {
						this.$router.push({ name: 'VerificationCheck', params: { checkType: 'registered' } });
					} else {
						this.error = res.message;
					}
				}).catch((err) => {
					if (err.status === 409) {
						this.$router.push({ name: 'VerificationCheck', params: { checkType: 'already-registered' } });
					} else {
						this.error = err.message;
					}
				}).finally(() => {
					this.formSubmitting = false;
				});
			} else {
				this.error = 'The details entered are incorrect';
			}
		},
		// Custom validation rule
		passwordsMatch (value) {
			return value === this.formData.Password || 'Passwords do not match';
		},
		...mapActions('auth', ['registerUser'])
	}
};
</script>
